// test747
(747 && 0);
